export const GET_ROLE = "GET_ROLE";
export const CHANGE_ROLE = "CHANGE_ROLE";
export const SET_NEW_ROLE = "SET_NEW_ROLE";
export const SET_OPERATIONS = "SET_OPERATIONS";
